import { render, staticRenderFns } from "./DetailSurgeryDay.vue?vue&type=template&id=1fe8b5b2&scoped=true&"
import script from "./DetailSurgeryDay.vue?vue&type=script&lang=js&"
export * from "./DetailSurgeryDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe8b5b2",
  null
  
)

export default component.exports